import { CheckCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import styles from './configuration-steps.module.scss';

/**
 * Configuration Steps Component
 *
 * A reusable component that displays a series of steps with completion status.
 *
 * @param {Object} props - Component props
 * @param {Array} props.steps - Array of step objects with id, label, and isCompleted properties
 * @param {string} props.className - Additional CSS class name
 */
export const ConfigurationSteps = ({ steps = [], className = '' }) => {
  return (
    <div className={`${styles.stepsContainer} ${className}`}>
      {steps.map((step) => (
        <div key={step.id} className={styles.stepItem}>
          <div className={`${styles.stepIndicator} ${step.isCompleted ? styles.completed : ''}`}>
            {step.isCompleted && <CheckCircleOutlined />}
          </div>
          <div className={styles.stepLabel}>{step.label}</div>
        </div>
      ))}
    </div>
  );
};

ConfigurationSteps.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      isCompleted: PropTypes.bool.isRequired,
    })
  ),
  className: PropTypes.string,
};
